define('viewmodels/Calculations/ReportManagement',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'durandal/system', 'services/logger', 'services/utils'], function (ko, router, appsecurity, navigation, app, system, logger, utils) {

    var RmViewModel = {
        activate: activate,
        attached: attached,
        appsecurity: appsecurity,
        utils: utils,
        ClickUploaddocument: ClickUploaddocument,
        popUpTitle: ko.observable(),
        EditUserDetails: ko.observable(true),
        getoptions: getoptions,
        DocumentTypeList: ko.observableArray(),
        DocumentTypeListDup: ko.observableArray(),
        ControlsAccess: ko.observable(false),
        addPopUpCss: ko.observable(),
        valuedoctype: ko.observable(),
        FolderName: ko.observable(),
        UploadDocument: UploadDocument,
        comments: ko.observable(),
        UploadReportDetails: UploadReportDetails,
        YearofAssessment: ko.observable(),
        YearChanged: YearChanged,
        docpath: ko.observable(),
        ReportDetailsList: ko.observableArray(),
        EditReportPopUp: EditReportPopUp,
        EditDocumentDetails: ko.observableArray(),
        LowestOptionSprocList: ko.observableArray(),
        LowestOptionList: ko.observableArray(),
        Optionvaluedoctype: ko.observable(),
        CurrentYear: ko.observable(),
        ReportModelCount: ko.observable(0),
        DownloadReport: DownloadReport,
        DeleteReportPopUp: DeleteReportPopUp,
        Savedisabled: ko.observable(true),
        UploadFileSize: ko.observable(1073741824),
        CurrentProfile :ko.observable(),
        SaveDocument: SaveDocument,
        ProfileofAssessmentList: ko.observableArray(),
        SrNo: ko.observable(0),
        LocaleCheckFlag: ko.observable(false)
    };
    return RmViewModel;

    function activate() {
        try {
            RmViewModel.EditDocumentDetails(new ReportDetailsModel({ DocumentType: '', DocumentUploadedforYear: '', DocumentComments: "", DocumentPath: "" }));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {
            if (appsecurity.WriteAccess()) {
                RmViewModel.ControlsAccess(true);
            }
            else {
                RmViewModel.ControlsAccess(false);
            }
            getProfileOfAssessmentDetails();
            getoptions();
            getReportDetails();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function DownloadReport(data, event) {
        try {
            for (var i= 0; i < RmViewModel.ProfileofAssessmentList().length;i++)
            {
                if (data.DocumentUploadedforProfile() == RmViewModel.ProfileofAssessmentList()[i].Profilename()) {
                    var Profile = RmViewModel.ProfileofAssessmentList()[i].ProfileId();
                    break;
                }

            }
            for (var i = 0; i < RmViewModel.DocumentTypeList().length; i++) {
                if (data.DocType() == RmViewModel.DocumentTypeList()[i].DocCode()) {
                    var DocType = RmViewModel.DocumentTypeList()[i].DocType();
                    break;
                }

            }
            // replacing ' (apostrophe) with empty space - from the doc name as it is causing issue in utils.postAndRedirect while creating html form
            var cleanDocName = data.DocumentName().toString().replace(/[']/g, '');
            var payLoad = {
                t: appsecurity.getAuthenticationInfo(), FilePath: data.DocPath().substring(data.DocPath().lastIndexOf('}'), 0), Profile: Profile, DocType: DocType, FileName: cleanDocName
            };
            utils.postAndRedirect(rootPath + "/FileDownload/DownloadReportFile", payLoad, '_blank');
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadReport() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function YearChanged(data, event) {
        try {
            if (event.target.value.length == 4 && !isNaN(event.target.value) && event.target.value.indexOf(' ') == -1) {
                document.getElementById("valfactorerror").innerHTML = "";
                $(valfactorerror).hide();
                RmViewModel.Savedisabled(true);
            }
            else {
                $(valfactorerror).show();

                document.getElementById("valfactorerror").innerHTML = "Please enter valid Year of Assessment";
                RmViewModel.Savedisabled(false);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: YearChanged() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getReportDetails() {
        try {
            try {
            
                $.ajax({
                    url: "/api/Calculation/GetReportDetails",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {

                    RmViewModel.SrNo(0);
                    if (jsonResult != null) {

                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null)
                        {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RmViewModel), true);
                        }

                        else {

                        RmViewModel.SrNo(0);
                        var mappedUserDetails = $.map(jsonResult, function (result) {
                            return new ReportDetailsModel(result);
                        });


                        tableObj = $('#tblReportDetails').DataTable();
                        tableObj.destroy();
                        $('#tblReportDetails tbody tr').remove();
                        QuestionTableObj = undefined;
                        RmViewModel.ReportDetailsList([]);
                        RmViewModel.ReportDetailsList(mappedUserDetails);
                        QuestionTableObj = $('#tblReportDetails').DataTable({
                            "aoColumnDefs": [{
                                "aTargets": [0],
                                "bVisible": false,
                                "bResponsive": true
                            },
                            {
                                "aTargets": [1],
                                "bVisible": true,
                                "bSortable": true,
                                "bResponsive": true
                            },
                            {
                                "aTargets": [2],
                                "bVisible": true,
                                "bSortable": false,
                                "bResponsive": true
                            }, {
                                "aTargets": [3],
                                "bVisible": true,
                                "bResponsive": true
                            },
                            {
                                "aTargets": [4],
                                "bSortable": true,
                                "bResponsive": true
                            },
                            {
                                "aTargets": [5],
                                "bSortable": true,
                                "bResponsive": true
                            },

                            {
                                "aTargets": [6],
                                "bSortable": true,
                                "bResponsive": true
                            },
                            {
                                "aTargets": [7],
                                "bSortable": true,
                                "width": "3em",
                                "bAutoWidth": false,
                                "bResponsive": true
                            },
                            {
                                "aTargets": [8],
                                "bVisible": false,
                                "bResponsive": true

                            },
                            {
                                "aTargets": [9],
                                "bSortable": false,
                                "sClass": "text-center",
                                "bVisible": RmViewModel.ControlsAccess(),
                                "bResponsive": true
                            }]

                        });

                        $('#tblQualQuestions').DataTable().draw(false);
                    }
                }
                    else
                        logger.logError('Some Error Occured while Fetching Active Roles', 'Error', system.getModuleId(RmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getReportDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getProfileOfAssessmentDetails() {
        try {
       
            $.ajax({
                url: "/api/Calculation/GetProfileAssessmentData",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
            .success(ajaxSuccess)
            .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getProfileOfAssessmentDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {

                if (jsonResult != null)
                {

                    if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                        logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RmViewModel), true);
                    }

                    if (jsonResult.length > 0) {
                        var MappedYearofAssessment = $.map(jsonResult, function (result) {
                            return new ProfileofAssessmentModel(result);
                        });
                        RmViewModel.ProfileofAssessmentList([]);
                        RmViewModel.ProfileofAssessmentList(MappedYearofAssessment);
                    }
                    else
                        logger.logError('An error occurred while fetching the Assessment Profiles. Please contact your application administrator.', 'Error', system.getModuleId(RmViewModel), true);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                var msg = 'Exception: ' + error + ' | Source: ajaxSuccess from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail from getProfileOfAssessmentDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

    }

    function ClickUploaddocument() {
        try {
            var NewDataObj = new ReportDetailsModel({ DocumentType: RmViewModel.valuedoctype(), DocumentUploadedforYear: RmViewModel.CurrentYear(), DocumentComments: "", DocumentPath: "" });
            RmViewModel.LowestOptionList([]);
            RmViewModel.LowestOptionSprocList([]);
            RmViewModel.DocumentTypeList([]);
            RmViewModel.DocumentTypeList(RmViewModel.DocumentTypeListDup())
            RmViewModel.EditDocumentDetails(NewDataObj);
            RmViewModel.popUpTitle("Upload Document");
            RmViewModel.addPopUpCss(true);
            $('#adddoc').modal('show');
            setTimeout("$('#yearinput').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ClickUploaddocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function SaveDocument() {
        try {
            if (RmViewModel.EditDocumentDetails().DocComments() == undefined) {
                document.getElementById('valfactorerror').innerHTML = "Please enter comments.";
            }
            else {
                UploadDocument();
            }


        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function getoptions() {
        try {
            try {
                $.ajax({
                    url: "/api/Calculation/Getdoctype",
                    type: "GET",
                    headers: appsecurity.getSecurityHeaders()
                })
                .success(ajaxSuccess)
                .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in getoptions() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {

                        if (jsonResult.length > 0 && jsonResult[0].Incident_Description != null) {
                            logger.logError(jsonResult[0].Incident_Description + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RmViewModel), true);
                        }

                        else {
                            var mappedUserDetails = $.map(jsonResult, function (result) {
                                return new Doctypes(result);
                            });
                            RmViewModel.DocumentTypeList(mappedUserDetails);
                            RmViewModel.DocumentTypeListDup(mappedUserDetails);
                        }
                    }
                    else
                        logger.logError('Some Error Occured while Fetching options', 'Error', system.getModuleId(RmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetActiveRoles() method in UserRole.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in getoptions() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in getoptions() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: getoptions() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function EditReportPopUp(data, event) {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditReportPopUp() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function deleteReport(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Calculation/DeleteReport?DocId=" + data.DocId(),
                headers: headers,
                type: "POST"

            })
            .success(ajaxSuccess)
            .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteReport() method in ReportManagement.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult != null) {
                    if (jsonResult == "1") {
                        logger.logSuccess('Report Deleted sucessfully.', 'Success', system.getModuleId(RmViewModel), true);
                        getReportDetails();
                    }
                    else {
                        logger.logError(jsonResult + " - " + 'An error occurred. Please contact your Application Administrator.', 'Error', system.getModuleId(RmViewModel), true);
                    }
                }
                else
                    logger.logError('Some Error Occured while Deleting Report', 'Error', system.getModuleId(RmViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteReport() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK")
                            navigation.unauthorized();

                    })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteReport() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteReport() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        };

    }

    function DeleteReportPopUp(data, event) {
        try {
            try {
                app.showMessage('Are you sure you want to delete this Report?', 'Delete Report', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            deleteReport(data, event);
                        }
                    });

            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteReportPopUp() method in ReportManagement.js';
                logger.logMessage(msg);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteReportPopUp() method in ReportManagement.js';
            logger.logMessage(msg);
        }


    }

    function UploadDocument(data, event) {
        try {
            $('#valfactorerror').hide();
            var FileList = document.getElementById('FileUploader').files;
            if (FileList.length > 0)
            {
                var FileName = document.getElementById('FileUploader').files[0].name;
                if (FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'JPG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'JPEG' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'DOCX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'DOC' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'XLS' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'PDF' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'XLSX' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'XLSM' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'BMP' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'RTF' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'CSV' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'TXT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                    FileName.length).toUpperCase() == 'PPT' | FileName.substring(FileName.lastIndexOf('.') + 1,
                        FileName.length).toUpperCase() == 'PPTX')
                {
                    if (FileList[0].size <= 1073741824) {

                        document.getElementById('valfactorerror').innerHTML = "";

                        var FormDataObj = new FormData();
                        FormDataObj.append("File1", FileList[0]);
                        var request = new XMLHttpRequest();

                        request.onreadystatechange = function () {
                            if (request.readyState == 1) {
                                document.getElementById('valfactorerror').innerHTML = "Initializing File Upload...";
                                $('#valfactorerror').show();
                            }
                            else if (request.readyState == 4)
                            {
                                if (request.status == 200) {
                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                        document.getElementById('valfactorerror').innerHTML = "File has been uploaded successfully.";
                                        $('#valfactorerror').show();
                                        UploadReportDetails(JSON.parse(request.response));
                                        var DocName = document.getElementById('FileUploader').files[0].name;
                                        document.getElementById('FileUploader').value = null;
                                        $('#adddoc').modal('hide');
                                        $('body').removeClass('modal-open');
                                        $('.modal-backdrop').remove();
                                    }
                                    else {
                                        document.getElementById('valfactorerror').innerHTML = "The file could not be uploaded.";
                                        $('#valfactorerror').show();
                                        document.getElementById('FileUploader').value = null;
                                    }
                                }
                                else
                                    ajaxFail(request, "");
                            }
                        };
                        request.upload.addEventListener('progress', function (event) {
                            document.getElementById('valfactorerror').innerHTML = "Uploading File...";

                        });
                        request.withCredentials = true;
                        for (var i = 0; i < RmViewModel.DocumentTypeList().length; i++) {
                            if (RmViewModel.DocumentTypeList()[i].DocCode() == RmViewModel.valuedoctype()) {
                                RmViewModel.FolderName(RmViewModel.DocumentTypeList()[i].DocType());
                                break;
                            }
                        }
                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                        var headers = appsecurity.getSecurityHeaders();
                        headers.__RequestVerificationToken = csrfToken;
                        request.open('POST', '/api/Calculation/FileUpload?profileofassessment=' + RmViewModel.CurrentProfile() + "&Doctype=" + RmViewModel.FolderName());
                        request.setRequestHeader('Authorization', headers.Authorization);
                        request.setRequestHeader('RT', headers.RT);
                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                        request.send(FormDataObj);

                    }
                    else
                    {
                        document.getElementById('valfactorerror').innerHTML = "Upload File Size cannot exceed " + (RmViewModel.UploadFileSize() / 1048576) + " MB. Please Try Uploading a file of lesser size.";
                        $('#valfactorerror').show();
                    }
                }
                else
                {
                    $('#valfactorerror').show();
                    document.getElementById('valfactorerror').innerHTML = "Please Select Valid File to Upload";
                }
            }

            else
            {
                $('#valfactorerror').show();
                document.getElementById('valfactorerror').innerHTML = "Please Select a File to Upload";
            }
            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK") {

                            }
                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocument() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in ReportManagement.js';
            logger.logMessage(msg);
        }

    }

    function UploadReportDetails(docpath) {
        try {
            var DocumnentName = docpath.substring(docpath.lastIndexOf('}') + 1, docpath.length)
            RmViewModel.docpath(docpath);
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Calculation/UploadReportDetails?profile=" + RmViewModel.CurrentProfile() + "&docname=" + DocumnentName + "&docpath=" + RmViewModel.docpath() + "&type=" + $("#AmlDrpDwn option:selected").val() + "&comments=" + RmViewModel.EditDocumentDetails().DocComments(),
                    headers: headers,
                    type: "POST"
                })
        .success(ajaxSuccess)
        .fail(ajaxFail);
            }

            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in UploadReportDetails() method in ReportManagement.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult == 1) {
                            logger.logSuccess('Report Uploaded Successfully.', 'Success', system.getModuleId(RmViewModel), true);
                            getReportDetails();
                        }
                        else if (jsonResult == 0) {
                            logger.logError((!RmViewModel.LocaleCheckFlag() || RmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage') == -1) ? 'An error occurred while saving as the Comment contains some invalid characters.' : RmViewModel.ObjGeneralSettings.LocalizedTextList()[RmViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('InvalidCommentCharsMessage')].Name(), 'Error', system.getModuleId(RmViewModel), true);
                        }
                    }
                    else
                        logger.logError('Some Error Occured while Uploading Report', 'Error', system.getModuleId(RmViewModel), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UploadReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {

                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();

                        })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UploadReportDetails() method in ReportManagement.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadReportDetails() method in ReportManagement.js';
                    logger.logMessage(msg);
                }
            };
        }

        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UploadReportDetails() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    //model definition starts here
    function Doctypes(item) {
        try {
            var self = this;
            self.DocType = ko.observable($('<div/>').html(item.Doctype).text());
            self.DocCode = ko.observable($('<div/>').html(item.Type).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Doctypes() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }

    function ReportDetailsModel(item) {
        try {
            var self = this;
            RmViewModel.SrNo(RmViewModel.SrNo() + 1);
            self.SrNo = ko.observable(RmViewModel.SrNo());
            self.DocId = ko.observable($('<div/>').html(item.DocumentId).text());
            self.DocComments = ko.observable($('<div/>').html(item.DocumentComments).text());
            self.DocumentName = ko.observable($('<div/>').html(item.DocumentName).text());
            self.DocumentUploadedforProfile = ko.observable($('<div/>').html(item.DocumentUploadedforProfile).text());
            self.DocType = ko.observable($('<div/>').html(item.DocumentType).text());
            self.UploadedDate = ko.observable($('<div/>').html(item.UploadedDate).text())
            self.UserName = ko.observable($('<div/>').html(item.UserName).text());
            self.DocPath = ko.observable($('<div/>').html(item.DocumentPath).text());

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ReportDetailsModel() method in ReportManagement.js';
            logger.logMessage(msg);
        }
    }


    //Model to Store the Profileofassessmentdetails
    function ProfileofAssessmentModel(item) {
        try {
            var self = this;
            self.ConfigurationFreezeFlag = ko.observable('true');
            self.Fromdate = ko.observable($('<div/>').html(item.Fromdate).text());
            self.Todate = ko.observable($('<div/>').html(item.Todate).text());
            self.ProfileId = ko.observable($('<div/>').html(item.ProfileId).text());
            self.Profilename = ko.observable($('<div/>').html(item.Profilename).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ProfileofAssessmentModel() method in CalculationStatus.js';
            logger.logMessage(msg);
        }
    }

    //------------------------------------------------------------------------Logic to Fetch User Details and List of All Roles Starts Here----------------------------------------------



    //------------------------------------------------------------------------Model Definition Ends Here-----------------------------------------------------------------------------

});
